import React, { useMemo } from "react";
import LodgingsEmptyComponent from "@tripbuilder/cat-accommodation/middle/EmptyLodgings";
import useTripStore from "@/stores/tripBuilder/useTrip";
import useAccommodationStore from "@/stores/tripBuilder/useAccommodation";

interface BedType {
  type: string;
  quantity: number;
}

interface Room {
  name: string;
  description: string;
  price: number;
  imageUrl: string;
  amenities: string[];
  numberOfPeople: number;
  bedTypes?: BedType[];
  numberOfBathrooms: number;
}

interface Friend {
  id: string;
  name: string;
  roomType: string;
  avatar: string;
  isBooker?: boolean;
}

interface McAccommodationProps {}

const McAccommodation: React.FC<McAccommodationProps> = () => {
  const lodgings = useAccommodationStore((state) => state.lodgings);

  const { selectedLocation, checkIsAdmin } = useTripStore();
  const isAdmin = useMemo(() => checkIsAdmin(), [checkIsAdmin]);

  if (!selectedLocation) {
    return (
      <div className="w-full h-full flex items-center justify-center">
        <p className="text-neutral-500">Please select a location first</p>
      </div>
    );
  }

  return (
    <div
      className="w-full h-screen flex flex-col"
      style={{ height: "calc(100dvh - 9.5rem)" }}
    >
      <div className="flex flex-col h-full w-full">
        <LodgingsEmptyComponent
          locationName={selectedLocation.name}
          lodgings={lodgings}
          checkInDate={selectedLocation?.date.start_date}
          checkOutDate={selectedLocation?.date.end_date}
          isAdmin={isAdmin}
        />
      </div>
    </div>
  );
};

export default McAccommodation;
